var React = require('react');

function Sparks (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"2","height":"2","x":"-1","y":"-1","key":0}),React.createElement("rect",{"width":"2","height":"2","x":"-1","y":"-1","key":1}),React.createElement("rect",{"width":"2","height":"2","x":"-1","y":"-1","key":2}),React.createElement("rect",{"width":"2","height":"2","x":"-1","y":"-1","key":3}),React.createElement("rect",{"width":"2","height":"2","x":"-1","y":"-1","key":4}),React.createElement("rect",{"width":"2","height":"2","x":"-1","y":"-1","key":5}),React.createElement("rect",{"width":"2","height":"2","x":"-1","y":"-1","key":6})]);
}

Sparks.defaultProps = {"viewBox":"0 0 1100 800"};

module.exports = Sparks;

Sparks.default = Sparks;
